import React from 'react';

import QuizSuccessMultiActionsCard from '../../containers/../containers/Quiz/QuizSuccessMultiActionsCard';
import PetitionSuccessMultiActionsCard from '../../containers/Petition/PetitionSuccessMultiActionsCard';
import EmailSuccessMultiActionsCard from '../../containers/Email/EmailSuccessMultiActionsCard';
import RecordVideoSuccessMultiActionsCard from '../../containers/RecordVideo/RecordVideoSuccessMultiActionsCard';
import PollSuccessMultiActionsCard from '../../containers/Poll/PollSuccessMultiActionsCard';
import SentimentPollSuccessMultiActionsCard from '../../containers/SentimentPoll/SentimentPollSuccessMultiActionsCard';
import DonationSuccessMultiActionsCard from '../../containers/Donation/DonationSuccessMultiActionsCard';
import CallSuccessMultiActionsCard from '../../containers/Call/CallSuccessMultiActionsCard';
import VoteRegistrationSuccessMultiActionsCard from '../../containers/VoteRegistration/VoteRegistrationSuccessMultiActionsCard';
import ElectionReminderSuccessMultiActionsCard from '../../containers/ElectionReminder/ElectionReminderSuccessMultiActionsCard';
import CheckRegistrationSuccessMultiActionCard from '../../containers/CheckRegistration/CheckRegistrationSuccessMultiActionCard';
import FindPollingStationSuccessMultiActionCard from '../../containers/FindPollingStation/FindPollingStationSuccessMultiActionCard';
import VolunteerSuccessMultiActionCard from '../../containers/Volunteer/VolunteerSuccessMultiActionCard';
import { OpinionSuccessMultiActionCard } from '../../containers/Opinion/OpinionSuccessMultiActionCard';

export const actionSuccess = (
    type,
    actionIdentifier,
    thankYouText,
    thankYouTitle,
    recipientMask,
    useLocalRepresentative,
    partnerName,
    pollResults,
    quizResults,
    name,
    feedbackText,
    quizAnsweredCorrect,
    quizMakeAnswersUppercase,
    localRepresentativeState,
    noOfPeopleAnswered,
    theme
) => {
    switch (type) {
        case 'donation':
            return (
                <DonationSuccessMultiActionsCard
                    thankYouText={thankYouText}
                    partnerName={partnerName}
                />
            );
        case 'petition':
            return (
                <PetitionSuccessMultiActionsCard
                    thankYouText={thankYouText}
                    thankYouTitle={thankYouTitle}
                    useLocalRepresentative={useLocalRepresentative}
                />
            );
        case 'opinion':
            return (
                <OpinionSuccessMultiActionCard
                    thankYouText={thankYouText}
                    thankYouTitle={thankYouTitle}
                />
            );
        case 'email':
            return (
                <EmailSuccessMultiActionsCard
                    thankYouText={thankYouText}
                    thankYouTitle={thankYouTitle}
                    recipientMask={recipientMask}
                    useLocalRepresentative={useLocalRepresentative}
                    localRepresentativeState={localRepresentativeState}
                />
            );
        case 'recordvideo':
            return (
                <RecordVideoSuccessMultiActionsCard
                    thankYouText={thankYouText}
                    thankYouTitle={thankYouTitle}
                    recipientMask={recipientMask}
                    useLocalRepresentative={useLocalRepresentative}
                    localRepresentativeState={localRepresentativeState}
                />
            );
        case 'quiz':
            return (
                <QuizSuccessMultiActionsCard
                    feedbackText={feedbackText}
                    results={quizResults}
                    noOfAnswers={quizResults.length}
                    answeredCorrect={quizAnsweredCorrect}
                    makeUppercase={quizMakeAnswersUppercase}
                />
            );
        case 'poll':
            return (
                <PollSuccessMultiActionsCard
                    theme={theme}
                    results={pollResults}
                    questionText={name}
                    noOfAnswers={pollResults.length}
                    noOfPeopleAnswered={noOfPeopleAnswered}
                />
            );
        case 'sentimentpoll':
            return (
                <SentimentPollSuccessMultiActionsCard
                    noOfPeopleAnswered={noOfPeopleAnswered}
                />
            );
        case 'call':
            return (
                <CallSuccessMultiActionsCard
                    thankYouText={thankYouText}
                    thankYouTitle={thankYouTitle}
                    recipientMask={recipientMask}
                    localRepresentativeState={localRepresentativeState}
                    useLocalRepresentative={useLocalRepresentative}
                />
            );
        case 'voteregistration':
            return <VoteRegistrationSuccessMultiActionsCard />;
        case 'electionreminder':
            return <ElectionReminderSuccessMultiActionsCard />;
        case 'checkregistration':
            return <CheckRegistrationSuccessMultiActionCard />;
        case 'findpollingstation':
            return <FindPollingStationSuccessMultiActionCard />;
        case 'volunteer':
            return <VolunteerSuccessMultiActionCard />;
        default:
            return;
    }
};

export const actionCompleted = (action, completedActionIdentifiers) => {
    return completedActionIdentifiers.find(
        completed => completed.type === action.type && completed.id === action.identifier
    );
};

export const allCompletedActions = state => {
    return (state.email.actionIdentifier || [])
        .map(id => ({ id, type: 'email' }))
        .concat((state.tweet.actionIdentifier || []).map(id => ({ id, type: 'tweet' })))
        .concat((state.link.actionIdentifier || []).map(id => ({ id, type: 'link' })))
        .concat((state.call.actionIdentifier || []).map(id => ({ id, type: 'call' })))
        .concat(
            (state.voteRegistration.actionIdentifier || []).map(id => ({
                id,
                type: 'voteregistration'
            }))
        ) //eslint-disable-line
        .concat(
            (state.electionReminder.actionIdentifier || []).map(id => ({
                id,
                type: 'electionreminder'
            }))
        ) //eslint-disable-line
        .concat(
            (state.checkRegistration.actionIdentifier || []).map(id => ({
                id,
                type: 'checkregistration'
            }))
        ) //eslint-disable-line
        .concat(
            (state.findPollingStation.actionIdentifier || []).map(id => ({
                id,
                type: 'findpollingstation'
            }))
        ) //eslint-disable-line
        .concat(
            (state.petition.actionIdentifier || []).map(id => ({ id, type: 'petition' }))
        ) //eslint-disable-line
        .concat(
            (state.donation.actionIdentifier || []).map(id => ({ id, type: 'donation' }))
        ) //eslint-disable-line
        .concat((state.poll.actionIdentifier || []).map(id => ({ id, type: 'poll' })))
        .concat(
            (state.sentimentPoll.actionIdentifier || []).map(id => ({
                id,
                type: 'sentimentpoll'
            }))
        ) //eslint-disable-line
        .concat((state.quiz.actionIdentifier || []).map(id => ({ id, type: 'quiz' })))
        .concat((state.volunteer.actionIdentifier || []).map(id => ({ id, type: 'volunteer' }))) //eslint-disable-line
        .concat((state.recordVideo.actionIdentifier || []).map(id => ({ id, type: 'recordvideo' }))) //eslint-disable-line
        .concat((state.petition.actionIdentifier || []).map(id => ({ id, type: 'opinion' }))) //eslint-disable-line

};

export const useLocalRepresentative = state => {
    const actions = state.widget.actions.filter(a => {
        return a.order === state.widget.activeAction.order && !!a.representativeSearch;
    });
    return actions.length ? true : false;
};
